// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"109":"4ea4a088","398":"fe0b248c"}[chunkId] + ".js";
};